import {createAsyncThunk} from '@reduxjs/toolkit';
import api, {CustomAxiosConfig} from 'services/axios';

import {
  ConfirmVendorProInput,
  ConfirmVendorProResponse,
  CreateVendorProSnapshotInput,
  CreateVendorProSnapshotResponse,
  DeleteVendorProInput,
  DeleteVendorProResponse,
  GetVendorProDetailInput,
  GetVendorProDetailResponse,
  GetVendorProListInput,
  GetVendorProListResponse,
  GetVendorProPlansInput,
  GetVendorProPlansResponse,
  MarkVendorProDoneInput,
  MarkVendorProDoneResponse,
  PauseVendorProInput,
  PauseVendorProResponse
} from './types';

export const getVendorProList = createAsyncThunk<GetVendorProListResponse, GetVendorProListInput>(
  'vendorPro/getVendorProList',
  async (params, thunkApi) => {
    try {
      const response = await api.get(`/dasht/vendor-pro`, {
        params,
        goBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data?.data);
    } catch (error: any) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const createVendorProSnapshot = createAsyncThunk<
  CreateVendorProSnapshotResponse,
  CreateVendorProSnapshotInput
>('vendorPro/createVendorProSnapshot', async (input, thunkApi) => {
  try {
    const body = {
      start_date: input.start_date,
      polygon_ids: input.polygon_ids
    };
    const response = await api.post(`/dasht/vendor-pro?vendor_id=${input.vendor_id}`, body, {
      goBaseUrl: true
    } as CustomAxiosConfig);
    return thunkApi.fulfillWithValue(response.data);
  } catch (error: any) {
    return thunkApi.rejectWithValue(error);
  }
});

export const getVendorProPlans = createAsyncThunk<
  GetVendorProPlansResponse,
  GetVendorProPlansInput
>('vendorPro/getVendorProPlans', async (input, thunkApi) => {
  try {
    const response = await api.get(`/dasht/vendor-pro/plans?vendor_id=${input.vendor_id}`, {
      goBaseUrl: true
    } as CustomAxiosConfig);
    return thunkApi.fulfillWithValue(response.data);
  } catch (error: any) {
    return thunkApi.rejectWithValue(error);
  }
});

export const confirmVendorPro = createAsyncThunk<ConfirmVendorProResponse, ConfirmVendorProInput>(
  'vendorPro/confirmVendorPro',
  async (input, thunkApi) => {
    try {
      const body = {code: input.code};
      const response = await api.put(
        `/dasht/vendor-pro/confirm?vendor_id=${input.vendor_id}`,
        body,
        {
          goBaseUrl: true
        } as CustomAxiosConfig
      );
      return thunkApi.fulfillWithValue(response.data);
    } catch (error: any) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getVendorProDetail = createAsyncThunk<
  GetVendorProDetailResponse,
  GetVendorProDetailInput
>('vendorPro/getVendorProDetail', async (input, thunkApi) => {
  try {
    const response = await api.get(`/dasht/vendor-pro/${input.vendor_pro_id}`, {
      params: {vendor_id: input.vendor_id},
      goBaseUrl: true
    } as CustomAxiosConfig);
    return thunkApi.fulfillWithValue(response.data);
  } catch (error: any) {
    return thunkApi.rejectWithValue(error);
  }
});

export const deleteVendorPro = createAsyncThunk<DeleteVendorProResponse, DeleteVendorProInput>(
  'vendorPro/deleteVendorPro',
  async (input, thunkApi) => {
    try {
      const response = await api.delete(`/dasht/vendor-pro/${input.vendor_pro_id}`, {
        params: {vendor_id: input.vendor_id},
        goBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (error: any) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const markVendorProDone = createAsyncThunk<
  MarkVendorProDoneResponse,
  MarkVendorProDoneInput
>('vendorPro/markVendorProDone', async (input, thunkApi) => {
  try {
    const response = await api.put(
      `/dasht/vendor-pro/${input.vendor_pro_id}/done?vendor_id=${input.vendor_id}`,
      {vendor_pro_id: input.vendor_pro_id},
      {goBaseUrl: true} as CustomAxiosConfig
    );
    return thunkApi.fulfillWithValue(response.data);
  } catch (error: any) {
    return thunkApi.rejectWithValue(error);
  }
});

export const pauseVendorPro = createAsyncThunk<PauseVendorProResponse, PauseVendorProInput>(
  'vendorPro/pauseVendorPro',
  async (input, thunkApi) => {
    try {
      const response = await api.put(
        `/dasht/vendor-pro/${input.vendor_pro_id}/pause`,
        {pause: input.pause},
        {goBaseUrl: true} as CustomAxiosConfig
      );
      return thunkApi.fulfillWithValue(response.data);
    } catch (error: any) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
